module.exports = new __parcel__URL__("Druideskill_24.ae2d82f4.png").toString();